import { render, staticRenderFns } from "./StatementTab.vue?vue&type=template&id=3549db85&scoped=true"
import script from "./StatementTab.vue?vue&type=script&lang=js"
export * from "./StatementTab.vue?vue&type=script&lang=js"
import style0 from "./StatementTab.vue?vue&type=style&index=0&id=3549db85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3549db85",
  null
  
)

export default component.exports